import React, { useState } from "react";
import "./Overlay.css";

const Overlay = ({ visible, text, onClick }) => {
  return (
    <div>
      {visible && (
        <div className="overlay">
          <button className="overlay-button" onClick={onClick}>
            {text}
          </button>
        </div>
      )}
    </div>
  );
};

export default Overlay;
